import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import PublicLayout from '../../../components/layout/PublicLayout';
import './../home.scss';
import nietTeamImage from './../assets/hero_images/niet-team.jpg';
import TrendingContent from './../components/TrendingContent';
import MemberTestimonials from './../components/MemberTestimonials';
import GrowthTracking from './../components/GrowthTracking';
import VideoPreview from './../components/VideoPreview';
import MainImage from './../components/MainImage';
import FAQ from './../components/FAQ';
import ScreenWrapper from '../../../components/layout/screenWrapper';

const Home = () => {
  // const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleLoad = () => {
      setIsLoading(false);
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
      return () => {
        window.removeEventListener('load', handleLoad);
      };
    }
  }, []);

  return (
    <PublicLayout>
      <ScreenWrapper loading={isLoading}>
        <div className='home-container'>
          {/* <div className='rollover-banner'>ATTENTION PARTNERS!<br></br>
             On July 1 NIET will be processing the data rollover from the 2023 - 2024 academic year.<br></br>
             EE PASS will be down temporarily for a few hours on July 1.
          </div> */}
          {/* <div className='rollover-banner'>
             We are currently performing maintenance on EEPASS. We apologize for any disruptions and expect to be fully operational shortly. Thank you for your patience.
          </div> */}
          {/* <VideoPreview /> */}
          <MainImage />
          <br />
          <section aria-label="Hero">
            {/* 7.1: was a generic, unlabeled <div> - converted to <article> since this hero
                pitch (heading + description) is a self-contained unit of content within the
                Hero section. `<article>`'s implicit role is "article" (not a landmark region
                type), so nesting it inside the already-labelled `<section aria-label="Hero">`
                doesn't create a duplicate/redundant landmark. */}
            <article className='hero-container'>
              {/* <div className='hero-column'>
                <h1>Engage.</h1>
                <h1>Equip.</h1>
                <h1>Empower.</h1>
                <div className='header-content-desc'>
                  Evolve as an educator with real-time access to individualized training and the support to improve instruction and evaluation.
                </div>
                <div className='hero-column'>
                  <img src={nietTeamImage} className='hero-image' alt="NIET Team" />
                </div>
              </div> */}
              <div className='hero-column-single'>
                <h1>On-Demand Support For Every Educator</h1>
                <div className='header-content-desc'>
                  To better meet the evolving needs of educators, the EE PASS content library has been expanded with new features that make it easier 
                  to locate and use resources efficiently. With these enhancements, the content library has grown into a more comprehensive coaching 
                  hub now called the Educator Coaching Hub Online (ECHO). ECHO maintains all the traditional search and navigation tools users are 
                  familiar with, while introducing improved search capabilities through a closed-source system called Enhanced Search, making it 
                  even easier to access and apply high-quality instructional resources.
                </div>
              </div>
            </article>
            {/* 7.1: second self-contained hero content block (a supplementary call-to-action
                statement with its own heading) - also converted from a generic <div>. */}
            <article className='hero-container'>
              {/* 7.5 heading-order fix: was <h3>, which skipped a level directly under the
                  page's <h1> above. Promoted to <h2> so the Hero section's two headings form a
                  contiguous h1 > h2 hierarchy (see the parallel h1 > h2 fixes applied to the
                  Trending Content, Testimonials, Growth Tracking, and FAQ section headings). */}
              <h2 className="hero-header">
                Check out how <a href="https://www.niet.org/ee-pass/" target="_blank" rel="noreferrer">EE PASS makes an impact with educators</a>.
              </h2>
            </article>
          </section>

          <br /><br />
          <TrendingContent />
          <br /><br />
          <MemberTestimonials />
          <GrowthTracking />
          <br /><br />
          <FAQ />
        </div>
      </ScreenWrapper>
    </PublicLayout>
  );
};

export default Home;
